<template>
  <div class="layout-default">
    <!-- 顶部导航栏, 所有页面展示，tab 页和登录页不展示返回按钮 -->
    <van-nav-bar :title="navbarTitle" :left-arrow="showBack" fixed placeholder @click-left="onBack" />

    <!-- 页面主体 -->
    <main class="layout-default__main" :class="{ 'has-nav': !showTabbar }">
      <router-view v-slot="{ Component, route }">
        <keep-alive :include="cachedViews">
          <component :is="Component" :key="route.fullPath" />
        </keep-alive>
      </router-view>
    </main>

    <!-- 底部标签栏：动态生成 -->
    <van-tabbar v-if="showTabbar" route fixed placeholder safe-area-inset-bottom>
      <van-tabbar-item v-for="item in tabbarItems" :key="item.path" :to="item.path" :icon="item.icon">
        {{ item.title }}
      </van-tabbar-item>
    </van-tabbar>
  </div>
</template>

<script setup lang="ts">
  const route = useRoute()
  const router = useRouter()
  // navbar 标题：优先使用 navbarTitle，否则回退 title
  const navbarTitle = computed(() => route.meta.navbarTitle || route.meta.title || '')
  // 底部导航：meta.tab 为 true 时展示，默认 false
  const showTabbar = computed(() => route.meta.tab)
  // 返回按钮：tab 页和登录页不展示
  const showBack = computed(() => !route.meta.tab && route.name !== 'Login')
  // 从路由配置动态生成 tabbar 项
  const tabbarItems = computed(() =>
    router
      .getRoutes()
      .filter((r) => r.meta.tab)
      .map((r) => ({ path: r.path, title: r.meta.title || '', icon: r.meta.icon || '' }))
  )
  // keep-alive 缓存的组件名列表
  const cachedViews = computed(() => {
    const names: string[] = []
    router.getRoutes().forEach((r) => {
      if (r.meta.keepAlive && r.name) {
        names.push(r.name as string)
      }
    })
    return names
  })

  function onBack() {
    router.back()
  }
</script>

<style lang="scss" scoped>
  .layout-default {
    display: flex;
    flex-direction: column;
    height: 100vh;
    overflow: hidden;

    &__main {
      flex: 1;
      overflow-y: auto;
      -webkit-overflow-scrolling: touch;
    }
  }
</style>
